import _ from 'lodash';
import uuid4 from 'uuid/v4';
import React from 'react';

import Button from 'components/Button';
import Warning from 'components/Warning';
import ErrorBlock from 'components/ErrorBlock';
import {default as Modal, withModal} from 'components/Modal';
import {
  MODALS,
  cancelGocardlessCustomer,
  cancelGocardlessCustomerWarnings,
  fetchGocardlessCustomerAndInvitation
} from 'ducks/tenancy';
import {closeModal} from 'ducks/modals';

import './styles.css';

class CancelGocardlessCustomerModal extends React.Component<any> {
  componentDidMount() {
    const {gocardlessCustomerId} = this.props.data;

    this.props.cancelGocardlessCustomerWarnings(
      {gocardlessCustomerId},
      this.props.storeDataExtraActions(data => ({warnings: data.warnings}))
    );
  }

  cancelCustomer = () => {
    const {data: {gocardlessCustomerId, tenancyId}} = this.props;

    const successExtraActions = [
      ...this.props.closeModalExtraActions,
      () => closeModal(MODALS.GOCARDLESS_CUSTOMER_DETAIL),
      () => fetchGocardlessCustomerAndInvitation({tenancyId})
    ];

    const failureExtraActions = this.props.storeDataExtraActions(
      ({errors}) => ({errors})
    );

    this.props.cancelGocardlessCustomer(
      {gocardlessCustomerId},
      successExtraActions,
      failureExtraActions
    );
  };

  render() {
    const {warnings, errors} = this.props.data;

    return (
      <Modal
        show={true}
        onClose={this.props.closeModal}
        className="CancelGocardlessCustomerModal"
        type={Modal.SMALL}>
        <Modal.Header>
          <h3 className="heading">Cancel GoCardless Customer</h3>
        </Modal.Header>
        <Modal.Body>
          {!_.isEmpty(warnings) &&
            _.map(warnings, warning => {
              return <Warning key={uuid4()}>{warning}</Warning>;
            })}
          {errors && <ErrorBlock>{errors._error}</ErrorBlock>}
        </Modal.Body>
        <Modal.Footer>
          <Button red onClick={this.cancelCustomer}>
            Cancel customer
          </Button>
        </Modal.Footer>
      </Modal>
    );
  }
}

const mapStateToModalData = () => ({});
const mapDispatchToModalProps = {
  cancelGocardlessCustomer,
  cancelGocardlessCustomerWarnings
};

export default withModal(
  MODALS.CANCEL_GOCARDLESS_CUSTOMER,
  mapStateToModalData,
  mapDispatchToModalProps
)(CancelGocardlessCustomerModal);
